import { render, staticRenderFns } from "./DashboardPortalApi.vue?vue&type=template&id=31e9e088&scoped=true&"
import script from "./DashboardPortalApi.vue?vue&type=script&lang=js&"
export * from "./DashboardPortalApi.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPortalApi.vue?vue&type=style&index=0&id=31e9e088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e9e088",
  null
  
)

export default component.exports